import React from "react";
import SidebarTenagaKesehatan from "../../components/SidebarTenagaKesehatan";
import TopBarTenagaKesehatanDetail from "../../components/TopBarTenagaKesehatanDetail";
import ProfileTenagaKesehatan from "../../components/ProfileTenagaKesehatan";
import "../../CSS/ProfileTenagaKesehatan.css";

function HalamanProfileTenagaKesehatan() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarTenagaKesehatan />

      {/* Area kanan */}
      <div className="content">
        <TopBarTenagaKesehatanDetail />

        {/* Konten utama */}
        <div className="main-contentprofile">
          <ProfileTenagaKesehatan />
        </div>

        
      </div>
    </div>
  );
}

export default HalamanProfileTenagaKesehatan;
